/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".choose-btn[_ngcontent-%COMP%]{border-color:var(--primary-color);font-size:14px;width:100%}.selected[_ngcontent-%COMP%]{background-color:var(--primary-color);color:#fff}"];
export { styles as styles };
